export default "__VITE_ASSET__96685644__"